import { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { generateId, serializeLogDataFilters } from './utils';
import { Header } from '@tanstack/react-table';
import { DEFAULT_ATTRIBUTE } from './types';

export function useUpdateLogDataFilter(
  name: string,
  header: Header<any, unknown>
) {
  const {
    column: { getFilterValue, setFilterValue },
  } = header;
  const formValue = useWatch({ name });

  useEffect(() => {
    // Set column filter (and url parameter) when form data changes
    const serialized = serializeLogDataFilters(formValue);
    const filterValue = getFilterValue() ?? '';
    if (filterValue !== serialized) {
      setFilterValue(serialized);
    }
  }, [getFilterValue, setFilterValue, formValue]);

  const { setValue } = useFormContext();
  const filterValue = header.column.getFilterValue() as string;
  useEffect(() => {
    // Reset filter if reset externally
    if (!filterValue) {
      setValue(name, [
        {
          ...DEFAULT_ATTRIBUTE,
          id: generateId(),
        },
      ]);
    }
  }, [filterValue, name, setValue]);
}
